module.exports = __webpack_public_path__ + "media/images/logo_negro2-8153d63a5d309f704e99caa1a4d06cf3.png";